import { ContentType } from '@/@types/common'
import { PostFormValue } from '@/components/Post/PostForm/schemas'
import { RepostFormValue } from '@/components/Post/RepostForm/types'
import { compact } from 'lodash-es'
import { useWatch } from 'react-hook-form'
import { useLocalStorage } from 'react-use'

export type DraftFormValue<Type extends DraftType> = {
	[ContentType.POST]: PostFormValue
	[ContentType.REPOST]: RepostFormValue
}[Type]
export type DraftType = ContentType.POST | ContentType.REPOST
export function usePostDraftStorage<T = PostFormValue | RepostFormValue>(
	draftType: DraftType,
	id: string | undefined
) {
	return useLocalStorage<T>(compact([`${draftType}_DRAFT`, id]).join('_'))
}

export default function usePostDraft(type: DraftType) {
	const formValues = useWatch<DraftFormValue<typeof type>>()
	return usePostDraftStorage<PostFormValue | RepostFormValue>(
		type,
		type === ContentType.REPOST
			? (formValues as RepostFormValue).targetId
			: (formValues as PostFormValue).id
	)
}
